<template>
  <div class="product-widget mb-30">
    <h5 class="pt-title">Product Categories</h5>
    <div class="widget-category-list mt-20">
      <div class="single-widget-category pointer" v-for="c in categoryData" :key="c.id">
        <input type="checkbox" :id="`cat-item-${c.id}`" :class="{ checked: activeQuery == c.id }">
        <label @click="handleCategoryRoute(c.id)" :for="`cat-item-${c.id}`" class="pointer">
          {{ c.name }} <span></span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductCategories",
  data() {
    return {
      categoryData: [], // Initialize as an empty array
      activeQuery: "",
    }
  },
  watch: {
    "$route.query.web_category": {
      handler(newWebCategory) {
        this.fetchCategories(newWebCategory) // Fetch categories based on new web_category
      },
      immediate: true, // Trigger on initial load
    },
    "$route.query": {
      handler(newQuery) {
        this.activeQuery = newQuery.category || ''
        console.log('Active Query:', this.activeQuery)
      },
      immediate: true,
    },
  },
  methods: {
    async fetchCategories(web_category = this.$route.query.web_category) {
      if (!web_category) return // Prevent API calls if web_category is not set

      try {
        const response = await this.$axios.get('/website-prodcut-categories', {
          params: { web_category }, // Pass web_category as a query parameter
        })
        this.categoryData = response.data
        console.log("Fetched Categories:", this.categoryData)
      } catch (error) {
        console.error("Error fetching categories:", error)
      }
    },
    handleCategoryRoute(value) {
      const currentQuery = { ...this.$route.query } // Get existing query params
      currentQuery.category = value // Update the brand query param

      this.$router.push({
        path: '/shop',
        query: currentQuery
      })
    },
  },
  mounted() {
    this.activeQuery = this.$route.query.category

    this.fetchCategories() // Fetch categories when the component is mounted
  },
}
</script>

<style scoped>
.pointer {
  cursor: pointer;
}

.single-widget-category label::after {
  font-family: 'Font Awesome 5 Free';
  content: '\f00c';
  font-weight: 900;
  /* Ensures solid icon */
}
</style>
